import React, { useEffect, forwardRef } from "react"
import { Portal } from "components"
import { motion, AnimatePresence } from "framer-motion"
import styles from "css/Layer.module.css"
// dependency update - change useage
import { animate } from "animejs"
import LayerStates from "states/LayerStates"
import { useRecoilState } from "recoil"

const Layer = forwardRef(({ id, closeLayer, left, right, show, title, children, outside, callback, className }, ref) => {
	
	const [layers, setLayers] = useRecoilState(LayerStates)

	//#region variants
	const variants = {
		initial: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
		animate: {
			backdropFilter: "blur(5px)",
			WebkitBackdropFilter: "blur(5px)",
			backgroundColor: "rgba(0, 0, 0, 0.5)",
		},
		exit: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
	}

	const winVariants = {
		initial: {
			left: "110vw",
			transition: {
				duration: 0.2,
				type: "tween",
			},
		},
		animate: {
			left: "0vw",
			transition: {
				duration: 0.2,
				type: "tween",
			},
		},
		exit: {
			left: "110vw",
			transition: {
				duration: 0.2,
				type: "tween",
			},
		},
	}
	//#endregion

	//#region Methods
	const onComplete = type => {
		if (type === "exit") {
			if (callback) callback()
		}
	}

	const hideLayer = () => {
		closeLayer && closeLayer()
	}
	//#endregion

	// useEffect(() => {
	// 	console.log("layers 변경 발생");
	// 	console.log(layers);
	// }, [layers]);

	// useEffect(() => {
	// 	console.log("Layer에서 pushData 변경일어남!");
	// 	console.log("show : " + show);
	// 	if (show) {
	// 		// PUSH DATA 처리
	// 		if (pushData) {
	// 			const urlArr = (pushData.url).split("/");
	// 			console.log(urlArr);
	// 			if (urlArr[1] === "layer") {
	// 				// 기존에 열려있는 레이어 닫기
    //                 layers.map(fn => {
    //                     fn();
    //                     console.log("레이어 닫음12323");
    //                 });
    //                 setLayers([]);
	// 			}
	// 		}
	// 	}
	// }, [pushData]);

	//#region Effects	
	useEffect(() => {
		// layers State에 배열로 Open 되어있는 Layer를 닫는 function을 넣어두고 꺼내서 사용 하는 방식??
		const app = document.querySelector(".App")
		if (!app) return
		if (show) {
			setLayers([
				...layers,
				closeLayer
			])
			animate(app,{
				
				translateX: -50,
				ease: "outQuad",
				duration: 300,
				onComplete: () => {
					app.style.transform = ""
					// document.querySelector(".App").style.position = ""
					// document.querySelector(".App").style.width = ""
				},
			})
		} else {
			const newList = []
			layers.forEach(fn => {
				if(fn.toString() !== closeLayer.toString()) newList.push(fn)
			})

			console.log(newList);

			if (newList.length !== 0) {
				setLayers(newList)
			}

			animate(app,{
				
				translateX: 0,
				ease: "outQuad",
				duration: 300,
				onComplete: () => {
					app.style.transform = ""
				},
			})
		}
	}, [show])
	//#endregion

	return (
		<Portal>
			<AnimatePresence>
				{show && (
					<motion.div className={`${styles.Layer}${className ? ` ${className}` : ""}`} variants={variants} initial='initial' animate='animate' exit='exit' data-id={id} onAnimationComplete={onComplete}>
						<motion.div className={styles.win} ref={ref} variants={winVariants}>
							<div className={styles.wrap}>{children}</div>
							{outside && outside}
							<div className={styles.header}>
								<div className={styles.left}>
								{left && left}
								</div>
								<div className={styles.title}>
									{title}
								</div>
								<div className={styles.right}>
								{
									right ?
									right :
									<i className='icon_close' onClick={hideLayer} />
								}
								</div>
							</div>
						</motion.div>
					</motion.div>
				)}
			</AnimatePresence>
		</Portal>
	)
})

export default Layer
